import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Gap } from '../../gap/esm';
import { getDataTestId } from '../../shared/esm';
import { InputProgress } from './components/InputProgress/Component.js';
import { KeyPad } from './components/KeyPad/Component.js';
import 'react-transition-group';
import './components/InputProgress/useInputProgress.js';
import '@alfalab/icons-glyph/BackspaceXxlIcon';
import './components/KeyPadButton/Component.js';
import 'tslib';
import '../../button/esm/mobile';

var commonStyles = {"component":"pass-code__component_17qkh","inputProgressContainer":"pass-code__inputProgressContainer_17qkh","message":"pass-code__message_17qkh"};
require('./index.css');

var PassCode = forwardRef(function (_a, ref) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, dataTestId = _a.dataTestId, className = _a.className, leftAddons = _a.leftAddons, rightAddons = _a.rightAddons, rightAddonsTitle = _a.rightAddonsTitle, error = _a.error, success = _a.success, onChange = _a.onChange, _c = _a.maxCodeLength, maxCodeLength = _c === void 0 ? 10 : _c, codeLength = _a.codeLength, _d = _a.styles, styles = _d === void 0 ? {} : _d, disabled = _a.disabled;
    var passwordLen = codeLength || maxCodeLength;
    var handleChange = function (digit) {
        if (disabled) {
            return;
        }
        var newValue = value.concat(digit.toString());
        if (newValue.length <= passwordLen) {
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
        }
    };
    var handleClear = function () {
        if (disabled) {
            return;
        }
        if (value.length > 0) {
            onChange === null || onChange === void 0 ? void 0 : onChange(value === null || value === void 0 ? void 0 : value.slice(0, -1));
        }
    };
    return (React.createElement("div", { className: cn(commonStyles.component, styles.component, className), ref: ref, "data-test-id": getDataTestId(dataTestId, 'wrapper') },
        React.createElement("div", { className: cn(commonStyles.inputProgressContainer) },
            React.createElement(Gap, { size: 16 }),
            React.createElement(InputProgress, { dataTestId: dataTestId, value: value, maxCodeLength: maxCodeLength, codeLength: codeLength, error: Boolean(error), success: success }),
            React.createElement(Gap, { size: 26 })),
        React.createElement(KeyPad, { dataTestId: dataTestId, leftAddons: leftAddons, rightAddons: rightAddons, rightAddonsTitle: rightAddonsTitle, onClick: handleChange, onClear: handleClear, showClear: Boolean(value) })));
});
PassCode.displayName = 'PassCode';

export { PassCode };
